import {
  CalendarOutlined,
  CheckCircleOutlined,
  EditOutlined,
  FileOutlined,
} from "@ant-design/icons";
import { Button, Col, Row, Tag } from "antd";
import Contrainer from "../../components/Contrainer/Contrainer";
import Text from "../../components/Text/Text";
import color from "../../resource/color";
import _ from "lodash";
import { SCORE_MAPPING, SCORE_MAPPING_COLOR } from "../../definitions/score";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

export const EvaluationCard = ({
  year,
  type,
  item,
}: {
  year: string;
  type: "Mid" | "Final";
  item: any;
}) => {
  const DateFormat = "MMMM D, YYYY HH:mm";
  const navigate = useNavigate();
  return (
    <Col span={12}>
      <Contrainer
        style={{
          backgroundColor: "#F3F4FB",
          borderRadius: "24px",
          padding: "30px",
          height: "100%",
        }}
      >
        <Row justify={"space-between"} gutter={8}>
          <Col span={18}>
            {item.isSubmit ? (
              <Tag
                color={item.isEmployeeSubmit ? "#A6F4C5" : "#EFF4FF"}
                icon={
                  item.isEmployeeSubmit ? (
                    <CheckCircleOutlined style={{ color: "#027A48" }} />
                  ) : (
                    <EditOutlined style={{ color: "#004EEB" }} />
                  )
                }
                style={{
                  borderRadius: "5px",
                  borderColor: item.isEmployeeSubmit ? "#027A48" : "#84ADFF",
                }}
              >
                <span
                  style={{
                    color: item.isEmployeeSubmit ? "#027A48" : "#004EEB",
                  }}
                >
                  {item.isEmployeeSubmit ? "Acknowledged" : "Evaluated"}
                </span>
              </Tag>
            ) : (
              <Tag
                color="#FEF0C7"
                icon={<EditOutlined style={{ color: "#DC6803" }} />}
                style={{
                  borderRadius: "5px",
                  borderColor: "#FEDF89",
                }}
              >
                <span style={{ color: "#DC6803" }}>Waiting to Evaluation</span>
              </Tag>
            )}
            <br />
            <Text fontWeight={600} level={4}>
              {year} {type} Year Evaluation
            </Text>
            <br />
            {item.isSubmit && (
              <Text level={6}>
                <CalendarOutlined /> Reviewed:
                {item?.supervisorSubmitDate
                  ? dayjs(item?.supervisorSubmitDate).format(DateFormat)
                  : " -"}
              </Text>
            )}
            <br />
            {item.isEmployeeSubmit && (
              <Text level={6} style={{ color: "#039855" }}>
                <CheckCircleOutlined /> Acknowledged:{" "}
                {item?.employeeSubmitDate
                  ? dayjs(item?.employeeSubmitDate).format(DateFormat)
                  : " -"}
              </Text>
            )}
            <br />
            <Button
              style={{
                backgroundColor: item.isSubmit ? color.navy : color.gray,
                height: "40px",
              }}
              onClick={() =>
                navigate("/consentPerformance", { state: { getData: item } })
              }
              disabled={!item.isSubmit}
            >
              <Text color="white" fontWeight={700}>
                {item.isSubmit && !item.isEmployeeSubmit ? (
                  "View & Acknowledge"
                ) : (
                  <>
                    <FileOutlined /> <span>View Evaluation</span>
                  </>
                )}
              </Text>
            </Button>
          </Col>
          <Col span={6}>
            <Contrainer
              style={{
                borderRadius: "16px",
                padding: "10px",
                width: "100%",
              }}
            >
              <Row justify={"center"}>
                <Text fontWeight={400} level={3} color="gray">
                  Final Score :
                </Text>
              </Row>
              {item.isSubmit ? (
                <Row justify={"center"}>
                  <Text
                    fontWeight={600}
                    level={1}
                    color={SCORE_MAPPING_COLOR[item.pmsScores[0].pmsScoreValue]}
                  >
                    {SCORE_MAPPING[item.pmsScores[0].pmsScoreValue]}
                  </Text>
                </Row>
              ) : (
                <Row justify={"center"}>
                  <Text fontWeight={600} level={1}>
                    -
                  </Text>
                </Row>
              )}
            </Contrainer>
          </Col>
        </Row>
      </Contrainer>
    </Col>
  );
};

export const EmptyEvaluationCard = ({
  year,
  type,
}: {
  year: string;
  type: "13" | "14";
}) => (
  <Col span={12} key={13}>
    <Contrainer
      style={{
        backgroundColor: "#F3F4FB",
        borderRadius: "24px",
        padding: "30px",
        height: "100%",
      }}
    >
      <Row justify={"space-between"} gutter={8}>
        <Col span={18}>
          <br />
          <Text fontWeight={600} level={4}>
            {year} {type === "13" ? "Mid Year" : "Final Year"} Evaluation
          </Text>
        </Col>
        <Col span={6}>
          <Contrainer
            style={{
              borderRadius: "16px",
              padding: "10px",
              width: "100%",
            }}
          >
            <Row justify={"center"}>
              <Text fontWeight={400} level={3} color="gray">
                Final Score :
              </Text>
            </Row>
            <Row justify={"center"}>
              <Text fontWeight={600} level={1}>
                -
              </Text>
            </Row>
          </Contrainer>
        </Col>
      </Row>
    </Contrainer>
  </Col>
);
